import React, { Component, Fragment } from "react";
import { Redirect } from "react-router-dom";
import moment from "moment";

import { inject, observer } from "mobx-react";

import {
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    FormControl,
    InputAdornment,
    Input,
    FormHelperText,
    Switch,
    FormControlLabel
} from "@material-ui/core";

import NumberFormat from "react-number-format";
import { ProfileType, BookingStatusType, LegalEntityType } from "../../../types/enum";
import { legalEntityHasSuper } from "../../../helper/legalEntityHelper";

import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";

import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { Popover, Typography, Button } from "@material-ui/core";

import PropTypes from "prop-types";
import jwtDecode from "jwt-decode";

import { withStyles } from "@material-ui/core/styles";

const ENABLE_SUBSCRIPTION = process.env.REACT_APP_ENABLE_SUBSCRIPTION === "true";

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit
    }
});

@inject("bookingRequestStore", "profileStore", "agentVenueStore", "agentActStore", "templateStore", "commonStore")
@observer
class PrivateBookingFeeDetails extends Component {
    state = {
        approvalDialogOpen: false,
        checked: false,
        anchorEl: false,
        goToPaymentPage: false
    };

    handleNumberSetsChange = e => {
        this.props.bookingRequestStore.setBooking("setNumber", e.target.value);
    };

    handleExtraGigFeeChange = e => {
        let extraGigFee = e.target.value < 0 ? 0 : e.target.value;
        this.props.bookingRequestStore.setBooking("extraGigFee", extraGigFee);
    };

    handleCheckedChange = e => {
        this.setState({ checked: e.target.checked });
    };

    handleGigFeeChange = e => {
        const { agentCommissionType, agentCommissionFee } = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        let value = e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        value = !value ? '' : (value)
        let actGigFee = 0;
        let agentCommission = 0;
        this.props.bookingRequestStore.setBooking("gigFee", value);
      
        if (currentProfile?.type === ProfileType.Agent.ordinal) {
            var agentFee =  agentCommissionFee? parseFloat(agentCommissionFee) : 0
            if (agentCommissionType === 0) {
                actGigFee = parseFloat(value) - agentFee;
                agentCommission = agentFee;
            } else if (agentCommissionType === 1) {
                agentCommission = (agentFee / 100) * parseFloat(value);
                actGigFee = parseFloat(value) - agentCommission;
            }
            this.props.bookingRequestStore.setBooking("actFee", actGigFee);
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", agentCommission);
        } else if (currentProfile?.type === ProfileType.Musician.ordinal) {
            this.props.bookingRequestStore.setBooking("actFee", value);
        }
    };

    handleActFeeChange = e => {
        this.props.bookingRequestStore.setBooking("actFee", e.target.value);
    };

    handleAgentCommissionAmountChange = e => {
        this.props.bookingRequestStore.setBooking("agentCommissionAmount", e.target.value);
    };

    handleCommissionTypeChange = e => {
        this.props.bookingRequestStore.setBooking("agentCommissionType", e.target.value);
        this.props.bookingRequestStore.setBooking("agentCommissionFee", 0);
        this.props.bookingRequestStore.setBooking("actFee", 0);
        this.props.bookingRequestStore.setBooking("agentCommissionAmount", 0);
    };

    handleAgentCommissionChange = e => {
        const { gigFee, agentCommissionType } = this.props.bookingRequestStore.booking;
        let value = e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        value = !value ? '' : (value)
        let result = 0.0;
        if (agentCommissionType === 0) {
            if (parseFloat(value, 10) > parseFloat(gigFee, 10)) return false;
            result = (gigFee || 0) - e.target.value;
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", value);
        } else if (agentCommissionType === 1 && gigFee !== 0) {
            if (parseFloat(value, 10) > 100 || parseFloat(value, 10) < 0) return false;
            let diffFee = (gigFee / 100) * value;
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", parseFloat(diffFee).toFixed(2));
            result = parseFloat(gigFee - diffFee).toFixed(2);
        }
        this.props.bookingRequestStore.setBooking("agentCommissionFee", value);
        this.props.bookingRequestStore.setBooking("actFee", result);
    };

    handleImmediateInvoiceChange = (e, checked) => {
        this.props.bookingRequestStore.setBooking("immediateInvoice", checked);
        this.setState({
            ...this.state
        });
    };

    handleDepositDueChange = e => {
        const { dateStart } = this.props.bookingRequestStore.booking;

        this.props.bookingRequestStore.setBooking("depositDue", e.target.value);

        if (e.target.value === 0) {
            this.props.bookingRequestStore.setBooking("depositDueDate", moment());
        } else if (e.target.value === 1) {
            this.props.bookingRequestStore.setBooking("depositDueDate", moment(dateStart).subtract(14, "days"));
        } else if (e.target.value === 2) {
            this.props.bookingRequestStore.setBooking("depositDueDate", moment(dateStart).subtract(1, "months"));
        } else if (e.target.value === 3) {
            this.props.bookingRequestStore.setBooking("depositDueDate", moment());
        }
    };

    handleBalanceDueChange = e => {
        const { dateStart } = this.props.bookingRequestStore.booking;

        this.props.bookingRequestStore.setBooking("balanceDue", e.target.value);

        if (e.target.value === 0) {
            this.props.bookingRequestStore.setBooking("balanceDueDate", moment());
        } else if (e.target.value === 1) {
            this.props.bookingRequestStore.setBooking("balanceDueDate", moment(dateStart).subtract(14, "days"));
        } else if (e.target.value === 2) {
            this.props.bookingRequestStore.setBooking("balanceDueDate", moment(dateStart).subtract(1, "months"));
        } else if (e.target.value === 3) {
            this.props.bookingRequestStore.setBooking("balanceDueDate", moment());
        }
    };

    handleDepositDueDateChange = e => {
        this.props.bookingRequestStore.setBooking("depositDueDate", moment(e).startOf("day"));
    };

    handleBalanceDueDateChange = e => {
        this.props.bookingRequestStore.setBooking("balanceDueDate", moment(e).startOf("day"));
    };

    getBalanceAmount = () => {
        let { gigFee, depositAmount, totalFee,actFee, superFee } = this.props.bookingRequestStore.booking;
        let { booking } = this.props.bookingRequestStore
        const { currentProfile } = this.props.profileStore;

        gigFee = gigFee ? gigFee : 0;
        
        var fee = gigFee
        if(((!booking || !booking.id) || (booking && booking?.id && booking?.createdById === currentProfile?.id)) && currentProfile?.type === ProfileType.Musician.ordinal){
            if(booking.includeSuper && booking.isSuperFee){
                fee = parseFloat(parseFloat(actFee??0) - parseFloat(superFee??0)).toFixed(2)
            }else if(booking.isSuperFee){
                fee = totalFee > 0 ? totalFee : gigFee
            }else{
                fee = gigFee
            }
        }else{
            fee = totalFee > 0 ? totalFee : gigFee
        }

        depositAmount = depositAmount ? depositAmount : 0;
        
        var result = fee - depositAmount;
        // if(result < 0)  this.props.bookingRequestStore.addErrors(["balance"], "balance amount is under 0")
        if (isNaN(result)) return 0
        else return result.toFixed(2);
    };

    handlePopoverOpen = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handlePopoverClose = () => {
        this.setState({ anchorEl: false });
    };

    handleGoToPaymentpage = () => {
        this.setState({ goToPaymentPage: true });
    };

    handleActFeeChangeSuperLocal = () => {
        const { percentageFeeSuper,agentCommissionType, agentCommissionFee, agentCommissionAmount, gigFee , includeSuper,actFee, isSuperFee} = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        if(!actFee) return;
        let value = this.removeLeadingZerosRegex(actFee.toString())
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        
        value = !value ? '' : value
        this.props.bookingRequestStore.setBooking("actFee", value);
        var performanceFee = value
        if(value){
            if(agentCommissionFee && (currentProfile?.type === ProfileType.Agent.ordinal || currentProfile?.type === ProfileType.Staff.ordinal)){
                value = parseFloat(value) + parseFloat(agentCommissionFee)
            }
            if(isSuperFee){
                var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(performanceFee)).toFixed(2))
                if(includeSuper){
                    var feeWithoutSuper = (parseFloat(performanceFee) / ((percentageFeeSuper+100)/100))
                    superFee = (parseFloat(performanceFee) - feeWithoutSuper).toFixed(2)
                    this.props.bookingRequestStore.setBooking("totalFee", value);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }else{
                    var totalFee = parseFloat(value) + superFee
                    this.props.bookingRequestStore.setBooking("totalFee", totalFee);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }
                this.props.bookingRequestStore.setBooking("superFee", superFee);
            }else{
                this.props.bookingRequestStore.setBooking("totalFee", value);
                this.props.bookingRequestStore.setBooking("gigFee", value);
                this.props.bookingRequestStore.setBooking("superFee", 0);
            }
        }else{
            this.props.bookingRequestStore.setBooking("totalFee", 0);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
    };

    handleSetIsSuperFee = value => {
        this.props.bookingRequestStore.setBooking("isSuperFee", legalEntityHasSuper(value))
        
    }

    handleActFeeChangeSuper = e => {
        const { percentageFeeSuper,agentCommissionType, agentCommissionFee, agentCommissionAmount, gigFee , includeSuper, isSuperFee} = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        let value = this.removeLeadingZerosRegex(e.target.value)
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        
        value = !value ? '' : value
        this.props.bookingRequestStore.setBooking("actFee", value);
        var performanceFee = value
        if(value){
            if(agentCommissionFee && (currentProfile?.type === ProfileType.Agent.ordinal || currentProfile?.type === ProfileType.Staff.ordinal)){
                value = parseFloat(value) + parseFloat(agentCommissionFee)
            }
            if(isSuperFee){
                var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(performanceFee)).toFixed(2))
                if(includeSuper){
                    var feeWithoutSuper = (parseFloat(performanceFee) / ((percentageFeeSuper+100)/100))
                    superFee = (parseFloat(performanceFee) - feeWithoutSuper).toFixed(2)
                    this.props.bookingRequestStore.setBooking("totalFee", value);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }else{
                    var totalFee = parseFloat(value) + superFee
                    this.props.bookingRequestStore.setBooking("totalFee", totalFee);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }
                this.props.bookingRequestStore.setBooking("superFee", superFee);
            }else{
                this.props.bookingRequestStore.setBooking("totalFee", value);
                this.props.bookingRequestStore.setBooking("gigFee", value);
                this.props.bookingRequestStore.setBooking("superFee", 0);
            }
        }else{
            this.props.bookingRequestStore.setBooking("totalFee", 0);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
    };

     handleAgentCommissionChangeSuper = e => {
        const { actFee, agentCommissionType, superFee, includeSuper, isSuperFee } = this.props.bookingRequestStore.booking;
         let value = this.removeLeadingZerosRegex(e.target.value)
        
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')

        value = !value ? '' : value
        let result = 0.0;
        if (agentCommissionType === 0) {
            if (parseFloat(value, 10) > parseFloat(actFee, 10)) return false;
            result = (parseFloat(actFee) || 0) + parseFloat(value, 10);
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", value);
        } else if (agentCommissionType === 1 && actFee !== 0) {
            if (parseFloat(value, 10) > 100 || parseFloat(value, 10) < 0) return false;
            let diffFee = (parseFloat(actFee) / 100) * parseFloat(value, 10);
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", parseFloat(diffFee).toFixed(2));
            result = parseFloat(parseFloat(actFee) + parseFloat(diffFee)).toFixed(2);
        }
        this.props.bookingRequestStore.setBooking("agentCommissionFee", value);
        this.props.bookingRequestStore.setBooking("gigFee", result);

        if(isSuperFee){
            if(includeSuper){
                this.props.bookingRequestStore.setBooking("totalFee", result);
            }else{
                 var totalFee = parseFloat(result) + parseFloat(superFee)
                this.props.bookingRequestStore.setBooking("totalFee", totalFee);
            }
        }else{
            this.props.bookingRequestStore.setBooking("totalFee", result);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
    };
    removeLeadingZerosRegex(str) {
        if (str === null) {
            return null;
        }
        // The regex /^0+(?!$)/ matches one or more leading '0's (0+)
        // at the beginning of the string (^)
        // BUT only if they are NOT followed by the end of the string (?!$)
        // This ensures that a string like "000" becomes "0" instead of ""
        const result = str.replace(/^0+(?!$)/, '');

        // If the string was "000", the regex makes it "", so we convert to "0"
        // If the string was "0", the regex does nothing, it remains "0"
        // If the string was "001", the regex makes it "1"
        return result === '' && str.includes('0') ? '0' : result;
    }

     handleIncludeSuperFeeChanged = (e, checked) => {
        const { gigFee, actFee, percentageFeeSuper, isSuperFee } = this.props.bookingRequestStore.booking;

         if(gigFee){
            if(isSuperFee){
                var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(actFee)).toFixed(2))
                if(checked){
                    var feeWithoutSuper = (parseFloat(actFee) / ((percentageFeeSuper+100)/100))
                    superFee = (parseFloat(actFee) - feeWithoutSuper).toFixed(2)
                    this.props.bookingRequestStore.setBooking("totalFee", gigFee);
                }else{
                    var totalFee = parseFloat(gigFee) + superFee
                    this.props.bookingRequestStore.setBooking("totalFee", totalFee);
                }
                this.props.bookingRequestStore.setBooking("superFee", superFee);
            }else{
                this.props.bookingRequestStore.setBooking("totalFee", gigFee);
                this.props.bookingRequestStore.setBooking("superFee", 0);
            }
             this.setState({
            ...this.state
        });
        }
         this.props.bookingRequestStore.setBooking("includeSuper", checked);
    };

    render() {
        if (this.state.goToPaymentPage) return <Redirect to="../../billing/payment" />;
        const { classes } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        let { booking,bookableActs, error } = this.props.bookingRequestStore;
        let {
            gigFee,
            agentCommissionFee,
            actFee,
            agentCommissionType,
            agentCommissionAmount,
            status,
            immediateInvoice,
            createdById,
            dateStart,
            depositAmount,
            depositDue,
            depositDueDate,
            balanceDue,
            balanceDueDate,
            createInvoice,
            act,
            canUpdate,
            isSuperFee,
            includeSuper,
            totalFee,
            superFee,
            actName,
            percentageFeeSuper,
            actId
        } = booking;
        let { readOnly, isActChange } = this.props;
        const { currentProfile } = this.props.profileStore;
        let currencySymbol = currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$";
        const { token } = this.props.commonStore;
        let hasSubscribe = false;
        let currentType = this.props.profileStore.currentProfile?.typeString === "staff" ? "venue" : this.props.profileStore.currentProfile?.typeString;
        // if (token && currentProfile && jwtDecode(token).scope.filter(x => x === currentType).length > 0) hasSubscribe = true;
        let resentAct = booking.bookingRequests && booking.bookingRequests.length > 0 && booking.bookingRequests[0].act;

        if (token && currentProfile) hasSubscribe = true;

        if (!ENABLE_SUBSCRIPTION) {
            hasSubscribe = true;
        }
        if(isActChange){
            var selectedActs = bookableActs.filter(x=>x.id == actId)
            if(selectedActs && selectedActs.length){
                var selectedAct = selectedActs[0]
                this.handleSetIsSuperFee(selectedAct?.actAdmin?.legalEntity)
                if(legalEntityHasSuper(selectedAct?.actAdmin?.legalEntity)){
                    this.handleActFeeChangeSuperLocal()
                }
            } else {
                this.handleSetIsSuperFee(0)
            }
        }
        let NumberFormatCustom = props => {
            const { inputRef, onChange, ...other } = props;

            return (
                <NumberFormat
                    {...other}
                    ref={inputRef}
                    onValueChange={values => {
                        onChange({
                            target: {
                                value: values.value
                            }
                        });
                    }}
                    thousandSeparator
                    prefix={currencySymbol}
                />
            );
        };

        let modGigFee = parseFloat(agentCommissionFee) > parseFloat(gigFee);

        let confirmedEditable =
            status !== BookingStatusType.Cancelled.ordinal &&
            status !== BookingStatusType.Completed.ordinal &&
            moment(dateStart).endOf("day") >= moment() &&
            (!createdById || createdById === currentProfile?.id);

        const isAgent = currentProfile && currentProfile?.type === ProfileType.Agent.ordinal;
        const isStaff = currentProfile && currentProfile?.type === ProfileType.Staff.ordinal;
        var lineupSuperFee = false
        var lineup = null
        booking?.lineups?.forEach(x => {
             if (x.profileId == currentProfile?.id) {
                lineupSuperFee = x.isSuperFee
                lineup = x

             }

        })

        return (
            <Grid container spacing={8}>         
                { !legalEntityHasSuper(act?.actAdmin?.legalEntity) || !isSuperFee ? 
                    currentProfile?.id === createdById || canUpdate || (booking && (!booking.id || booking.id === 0)) ? (
                    <Grid item xs={12} lg={12} className="gridPrivateBookingForm">
                        <FormControl fullWidth>
                            <InputLabel htmlFor="gigFee">Gig Fee to Client (ex Tax)</InputLabel>
                            <Input
                                id="gigFee"
                                type="string"
                                value={gigFee}
                                onChange={this.handleGigFeeChange}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                readOnly={readOnly}
                            />
                        </FormControl>
                    </Grid>
                ) : currentProfile?.id !== createdById && !canUpdate && ((act && act.actAdminId === currentProfile?.id) || (resentAct && resentAct?.actAdminId === currentProfile?.id)) ? (
                    <Grid item xs={12} lg={12} className="gridPrivateBookingForm">
                        <FormControl fullWidth>
                            <InputLabel htmlFor="gigFee">Act Fee</InputLabel>
                            <Input
                                id="actFee"
                                value={actFee}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                readOnly={true}
                            />
                        </FormControl>
                    </Grid>
                ) : currentProfile?.id !== createdById && !canUpdate && act && act.actAdminId !== currentProfile?.id ? (
                    <Grid item xs={12} lg={12} className="gridPrivateBookingForm">
                        <FormControl fullWidth>
                            <InputLabel htmlFor="gigFee">Your Fee</InputLabel>
                            <Input
                                id="actFee"
                                value={actFee}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                readOnly={true}
                            />
                        </FormControl>
                    </Grid>
                ) : (
                    ""
                ):



                booking.id && (currentProfile?.id !== createdById && !canUpdate && act && act.actAdminId !== currentProfile?.id) ? (
                    <Fragment>
                        <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="gigFee">Your Fee</InputLabel>
                                <Input
                                    id="actFee"
                                    value={actFee}
                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                    readOnly={true}
                                />
                            </FormControl>
                        </Grid>
                        {/* <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth error={error && error["superFee"]}>
                                <InputLabel htmlFor="superFee">Invoice Amount</InputLabel>
                                <Input
                                    id="actInvoiceAmount"
                                    value={includeSuper ? parseFloat(parseFloat(actFee??0) - parseFloat(superFee??0)).toFixed(2) : parseFloat(actFee??0).toFixed(2)}
                                    type="string"
                                    readOnly={true}
                                    inputprops={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                />
                                {error && error["actInvoiceAmount"] ? <FormHelperText>{error["actInvoiceAmount"]}</FormHelperText> : ""}
                            </FormControl>
                        </Grid> */}
                    </Fragment>
                ) :
                <Fragment>
                    <Grid item xs={12} lg={6} className="gridBookingForm">
                        <FormControl fullWidth error={error && error["actFee"]}>
                            <InputLabel htmlFor="actFee">Performance Fee (ex Tax)</InputLabel>
                            <Input
                                id="actFeeAmount"
                                type="string"
                                value={actFee}
                                onChange={this.handleActFeeChangeSuper}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                readOnly={readOnly}
                            />
                            {error && error["actFee"] ? <FormHelperText>{error["actFee"]}</FormHelperText> : ""}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} className="gridBookingForm">
                        <FormControlLabel
                            control={
                                <Switch
                                        color="primary"
                                        checked={includeSuper}
                                        onChange={this.handleIncludeSuperFeeChanged}
                                        disabled={readOnly}
                                />
                            }
                            label={"Fee includes super"}
                        />
                    </Grid>
                  
                </Fragment>
                
                
                
                
                
              }

                {isAgent || isStaff ? (
                    legalEntityHasSuper(act?.actAdmin?.legalEntity) && isSuperFee ? 
                    <Fragment>
                        <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth error={error && error["agentCommissionFee"]}>
                                <InputLabel htmlFor="agentFee">Agent Commission</InputLabel>
                                <Input
                                    id="agentFee"
                                    error={
                                        (agentCommissionType === 0 && modGigFee) ||
                                        (agentCommissionType === 1 && (agentCommissionFee < 0 || agentCommissionFee > 100))
                                    }
                                    value={agentCommissionFee}
                                    onChange={this.handleAgentCommissionChangeSuper}
                                    type="string"
                                    readOnly={readOnly}
                                    inputprops={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <TextField
                                                select
                                                value={agentCommissionType}
                                                onChange={this.handleCommissionTypeChange}
                                                disabled={readOnly}
                                                SelectProps={{
                                                    className: "select-adornment",
                                                    inputProps: { className: "select-adornment-input" }
                                                }}
                                            >
                                                <MenuItem key={1} value={0}>
                                                    {currencySymbol}
                                                </MenuItem>
                                                <MenuItem key={2} value={1}>
                                                    %
                                                </MenuItem>
                                            </TextField>
                                        </InputAdornment>
                                    }
                                />
                                {error && error["agentCommissionFee"] ? <FormHelperText>{error["agentCommissionFee"]}</FormHelperText> : ""}
                            </FormControl>
                            <FormHelperText id="name-error-text">Percentage 0 to 100% and commission is not more than Gig Fee</FormHelperText>
                        </Grid>
                        <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="adornment-amount">Commission paid to Agent</InputLabel>
                                    <Input
                                        id="agentFeeAmount"
                                        type="text"
                                        value={Number(agentCommissionAmount || 0).toFixed(2)}
                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                        readOnly
                                    />
                            </FormControl>
                        </Grid>
                    </Fragment> :
                    <Fragment>
                        <Grid item xs={12} lg={4} className="gridPrivateBookingForm">
                            <FormControl fullWidth error={error && error["agentCommissionFee"]}>
                                <InputLabel htmlFor="agentFee">{isAgent ? "Agent Commission" : "Booking Fee"}</InputLabel>
                                <Input
                                    id="agentFee"
                                    error={
                                        (agentCommissionType === 0 && modGigFee) ||
                                        (agentCommissionType === 1 && (agentCommissionFee < 0 || agentCommissionFee > 100))
                                    }
                                    value={agentCommissionFee}
                                    onChange={this.handleAgentCommissionChange}
                                    type="string"
                                    readOnly={readOnly}
                                    inputprops={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <TextField
                                                select
                                                value={agentCommissionType}
                                                onChange={this.handleCommissionTypeChange}
                                                disabled={readOnly}
                                                SelectProps={{
                                                    className: "select-adornment",
                                                    inputProps: { className: "select-adornment-input" }
                                                }}
                                            >
                                                <MenuItem key={1} value={0}>
                                                    {currencySymbol}
                                                </MenuItem>
                                                <MenuItem key={2} value={1}>
                                                    %
                                                </MenuItem>
                                            </TextField>
                                        </InputAdornment>
                                    }
                                />
                                {error && error["agentCommissionFee"] ? <FormHelperText>{error["agentCommissionFee"]}</FormHelperText> : ""}
                            </FormControl>
                            <FormHelperText id="name-error-text">Percentage 0 to 100% and commission is not more than Gig Fee</FormHelperText>
                        </Grid>
                        <Grid item xs={12} lg={4} className="gridPrivateBookingForm">
                            <FormControl fullWidth error={error && error["actFee"]}>
                                <InputLabel htmlFor="actFee">Gig Fee Paid To Act (ex Tax)</InputLabel>
                                <Input
                                    id="actFeeAmount"
                                    type="number"
                                    value={actFee}
                                    onChange={this.handleActFeeChange}
                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                    readOnly
                                />
                                {error && error["actFee"] ? <FormHelperText>{error["actFee"]}</FormHelperText> : ""}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={4} className="gridPrivateBookingForm">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="adornment-amount">{isAgent ? "Commission paid to Agent" : "Booking Fee Amount"}</InputLabel>
                                    <Input
                                        id="agentFeeAmount"
                                        type="text"
                                        value={Number(agentCommissionAmount || 0).toFixed(2)}
                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                        readOnly
                                    />
                            </FormControl>
                        </Grid>
                    </Fragment>
                ) : (
                    ""
                )}

                {
                    (legalEntityHasSuper(act?.actAdmin?.legalEntity) && isSuperFee) && (booking?.createdById === currentProfile?.id || !booking.id) ? 
                    <Fragment>
                          <Grid item xs={12} lg={6} className="gridBookingForm">
                        <FormControl fullWidth error={error && error["totalFee"]}>
                            <InputLabel htmlFor="totalFee">{currentProfile?.type === ProfileType.Staff.ordinal ? "Fee Paid to Act" : "Total Fee to Client (ex Tax)"}</InputLabel>
                            <Input
                                type="text"
                                id="totalFee"
                                value={Number(totalFee || 0).toFixed(2)}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                readOnly={true}
                            />
                            {error && error["totalFee"] ? <FormHelperText>{error["totalFee"]}</FormHelperText> : ""}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6} className="gridBookingForm">
                        <FormControl fullWidth error={error && error["superFee"]}>
                            <InputLabel htmlFor="superFee">Super Paid to Act</InputLabel>
                            <Input
                                id="superFee"
                                value={superFee}
                                type="string"
                                readOnly={true}
                                inputprops={{
                                    inputComponent: NumberFormatCustom
                                }}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                            />
                            {error && error["superFee"] ? <FormHelperText>{error["superFee"]}</FormHelperText> : ""}
                        </FormControl>
                        <FormHelperText id="name-error-text">{`Percentage ${percentageFeeSuper}% of gig fee paid to act`}</FormHelperText>
                    </Grid>
                    <Grid item xs={12} lg={6} className="gridBookingForm">
                        <FormControl fullWidth error={error && error["superFee"]}>
                            <InputLabel htmlFor="superFee">Total Act Invoice</InputLabel>
                            <Input
                                id="actInvoiceAmount"
                                value={includeSuper ? parseFloat(parseFloat(actFee??0) - parseFloat(superFee??0)).toFixed(2) : parseFloat(actFee??0).toFixed(2)}
                                type="string"
                                readOnly={true}
                                inputprops={{
                                    inputComponent: NumberFormatCustom
                                }}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                            />
                            {error && error["actInvoiceAmount"] ? <FormHelperText>{error["actInvoiceAmount"]}</FormHelperText> : ""}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6} className="gridBookingForm"></Grid> 
                    </Fragment> : null
                }

 {
                (legalEntityHasSuper(act?.actAdmin?.legalEntity) && isSuperFee) && act?.actAdminId == currentProfile?.id && booking?.createdById != currentProfile?.id && booking.id ? 
                    <Fragment>
                    <Grid item xs={12} lg={6} className="gridBookingForm">
                        <FormControl fullWidth error={error && error["superFee"]}>
                            <InputLabel htmlFor="superFee">Super Paid to Act</InputLabel>
                            <Input
                                id="superFee"
                                value={superFee}
                                type="string"
                                readOnly={true}
                                inputprops={{
                                    inputComponent: NumberFormatCustom
                                }}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                            />
                            {error && error["superFee"] ? <FormHelperText>{error["superFee"]}</FormHelperText> : ""}
                        </FormControl>
                        <FormHelperText id="name-error-text">{`Percentage ${percentageFeeSuper}% of gig fee paid to act`}</FormHelperText>
                    </Grid>
                    <Grid item xs={12} lg={6} className="gridBookingForm">
                                                    <FormControl fullWidth error={error && error["superFee"]}>
                                                        <InputLabel htmlFor="superFee">Total Act Invoice</InputLabel>
                                                        <Input
                                                            id="actInvoiceAmount"
                                                            value={includeSuper ? parseFloat(parseFloat(actFee??0) - parseFloat(superFee??0)).toFixed(2) : parseFloat(actFee??0).toFixed(2)}
                                                            type="string"
                                                            readOnly={true}
                                                            inputprops={{
                                                                inputComponent: NumberFormatCustom
                                                            }}
                                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                        />
                                                        {error && error["actInvoiceAmount"] ? <FormHelperText>{error["actInvoiceAmount"]}</FormHelperText> : ""}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={6} className="gridBookingForm"></Grid> 
                    </Fragment> : null
                }

                  {
                    lineup && act?.actAdminId != currentProfile?.id && lineupSuperFee && booking?.createdById != currentProfile?.id ? 
                    <Fragment>
                    <Grid item xs={12} lg={6} className="gridBookingForm">
                        <FormControl fullWidth error={error && error["superFee"]}>
                            <InputLabel htmlFor="superFee">Super Paid to Act</InputLabel>
                            <Input
                                id="superFee"
                                value={parseFloat(lineup.superFee).toFixed(2)}
                                type="string"
                                readOnly={true}
                                inputprops={{
                                    inputComponent: NumberFormatCustom
                                }}
                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                            />
                            {error && error["superFee"] ? <FormHelperText>{error["superFee"]}</FormHelperText> : ""}
                        </FormControl>
                        <FormHelperText id="name-error-text">{`Percentage ${percentageFeeSuper}% of gig fee paid to act`}</FormHelperText>
                    </Grid>
                    <Grid item xs={12} lg={6} className="gridBookingForm">
                                                    <FormControl fullWidth error={error && error["superFee"]}>
                                                        <InputLabel htmlFor="superFee">Total Act Invoice</InputLabel>
                                                        <Input
                                                            id="actInvoiceAmount"
                                                            value={parseFloat(parseFloat(lineup.fee??0) - parseFloat(lineup.superFee??0)).toFixed(2)}
                                                            type="string"
                                                            readOnly={true}
                                                            inputprops={{
                                                                inputComponent: NumberFormatCustom
                                                            }}
                                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                        />
                                                        {error && error["actInvoiceAmount"] ? <FormHelperText>{error["actInvoiceAmount"]}</FormHelperText> : ""}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={6} className="gridBookingForm"></Grid> 
                    </Fragment> : null
                }

                {currentProfile?.id === createdById || canUpdate || (booking && (!booking.id || booking.id === 0)) ? (
                    <Fragment>
                        <Grid item xs={12} lg={3} className="gridPrivateBookingForm">
                            <TextField
                                id="deposit-amount"
                                label="Deposit Amount"
                                value={depositAmount}
                                error={!!this.props.bookingRequestStore.getPrivateBookingDepositError()}
                                helperText={this.props.bookingRequestStore.getPrivateBookingDepositError()}
                                onChange={e => this.props.bookingRequestStore.setBooking("depositAmount", e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))}
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
                                    type: "string",
                                    readOnly: readOnly
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={3} className="gridPrivateBookingForm">
                            <TextField select label="Deposit Due" value={depositDue} onChange={this.handleDepositDueChange} fullWidth>
                                <MenuItem key={0} value={0}>
                                    Today
                                </MenuItem>
                                <MenuItem key={1} value={1}>
                                    2 Weeks Before
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    1 Month Before
                                </MenuItem>
                                <MenuItem key={3} value={3}>
                                    Custom
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    className="booking-date-picker"
                                    keyboard
                                    value={moment(depositDueDate)}
                                    fullWidth
                                    margin="dense"
                                    onChange={this.handleDepositDueDateChange}
                                    label="Deposit Due Date"
                                    minDateMessage="Please choose a valid date: today or any future date."
                                    minDate={booking.id ? undefined : moment().startOf("days")}
                                    maxDate={moment(dateStart).endOf("days")}
                                    format="DD-MM-YYYY"
                                    keyboardIcon={<EventIcon />}
                                    leftArrowIcon={<KeyboardArrowLeftIcon />}
                                    rightArrowIcon={<KeyboardArrowRightIcon />}
                                    disabled={depositDue !== 3}
                                    style={{ marginTop: 0 }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} lg={3} className="gridPrivateBookingForm">
                            <TextField
                                id="balance-amount"
                                label="Balance"
                                value={this.getBalanceAmount()}
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>
                                }}
                                readOnly={true}
                                error={error && error["balance"]}
                                helperText={error && error["balance"] ? error["balance"] : ""}
                            />
                        </Grid>
                        <Grid item xs={12} lg={3} className="gridPrivateBookingForm">
                            <TextField select label="Balance Due" value={balanceDue} onChange={this.handleBalanceDueChange} fullWidth>
                                <MenuItem key={0} value={0}>
                                    Today
                                </MenuItem>
                                <MenuItem key={1} value={1}>
                                    2 Weeks Before
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    1 Month Before
                                </MenuItem>
                                <MenuItem key={3} value={3}>
                                    Custom
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    className="booking-date-picker"
                                    keyboard
                                    value={moment(balanceDueDate)}
                                    fullWidth
                                    margin="dense"
                                    onChange={this.handleBalanceDueDateChange}
                                    label="Balance Due Date"
                                    minDateMessage="Please choose a valid date: today or any future date."
                                    minDate={depositDueDate ? moment(depositDueDate).startOf("days") : moment().startOf("days")}
                                    maxDate={moment(dateStart).endOf("days")}
                                    format="DD-MM-YYYY"
                                    keyboardIcon={<EventIcon />}
                                    leftArrowIcon={<KeyboardArrowLeftIcon />}
                                    rightArrowIcon={<KeyboardArrowRightIcon />}
                                    disabled={balanceDue !== 3}
                                    style={{ marginTop: 0 }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                            <FormControlLabel
                                onMouseOver={this.handlePopoverOpen}
                                control={
                                    <Switch
                                        color="primary"
                                        onChange={(e, checked) => this.props.bookingRequestStore.setBooking("createInvoice", checked)}
                                        checked={createInvoice && hasSubscribe}
                                        disabled={!confirmedEditable || !hasSubscribe}
                                    />
                                }
                                label="Create Invoices"
                            />
                        </Grid>
                        <Popover
                            id="mouse-over-popover"
                            open={open && !hasSubscribe}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left"
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left"
                            }}
                            onClose={this.handlePopoverClose}
                            disableRestoreFocus
                        >
                            <div onMouseLeave={this.handlePopoverClose}>
                                <Typography className={classes.margin}>Upgrade to enable automated invoicing</Typography>
                                <Grid container xs={12} justify="center" className={classes.margin}>
                                    <Grid item>
                                        <Button align="center" variant="contained" color="primary" onClick={this.handleGoToPaymentpage}>
                                            Upgrade
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </Popover>
                    </Fragment>
                ) : (
                    ""
                )}
            </Grid>
        );
    }
}

PrivateBookingFeeDetails.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PrivateBookingFeeDetails);
